import { CheckboxCheckedChangeDetails } from "@chakra-ui/react";
import { useState } from "react";

export const useLocalHook = () => {
  const [isAgreementChecked, setAgreementChecked] = useState(false);

  const disabled = !isAgreementChecked;

  const handleOnCheckAgreement = (detail: CheckboxCheckedChangeDetails) => {
    setAgreementChecked(!!detail.checked);
  };

  return {
    disabled,
    isAgreementChecked,
    handleOnCheckAgreement,
  };
};
